import api from '../config/api';

/**
 * Generic API service class for making HTTP requests directly to backend API
 */
class ApiService {
    /**
     * Make a GET request
     * @param {string} endpoint - API endpoint
     * @param {object} params - Query parameters
     * @returns {Promise} Response data
     */
    async get(endpoint, params = {}) {
        try {
            const response = await api.get(endpoint, { params });
            return this.handleResponse(response);
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Make a POST request
     * @param {string} endpoint - API endpoint
     * @param {object} data - Request body
     * @returns {Promise} Response data
     */
    async post(endpoint, data = {}) {
        try {
            const response = await api.post(endpoint, data);
            return this.handleResponse(response);
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Handle successful response
     * @param {object} response - Axios response
     * @returns {object} Response data
     */
    handleResponse(response) {
        if (response.data && response.data.success !== undefined) {
            return response.data;
        }
        return response.data;
    }

    /**
     * Handle error response
     * @param {object} error - Error object
     * @returns {Error} Formatted error
     */
    handleError(error) {
        if (error.message && error.status !== undefined) {
            return error;
        }

        return {
            message: error.message || 'An error occurred. Please try again.',
            status: error.response?.status || 500,
            data: error.response?.data || {},
        };
    }
}

// Export singleton instance
const apiServiceInstance = new ApiService();
export default apiServiceInstance;
